import React, {memo, useEffect, useState} from 'react';
import ReactModal from 'react-modal';

import {ActionButton} from '../../../common';
import {Message} from '../../../utilites';
import {HRadio} from '../../../../validation/HForm'
import Loader from './Loader/Loader';
import './transferSaledModal.scss';
import OverestimationLayout from "../Overestimation/OverestimationLayout";
import {permissionsAccess} from "../../../../helpers/common";
import { paymentErrors } from '../../../../helpers/data-constants';
import {useSelector} from "react-redux";
import {FormProvider, useForm} from "react-hook-form";
import BasicAlert from "../../Alert/Alert";
import NonCash from "../../NonCash/NonCash";
import PaymentTypeSelector from '../../PaymentSelector/PaymentTypeSelector';
import transferSaledModalSchema from "./TransferSaledModalSchema";
import {joiResolver} from "@hookform/resolvers/joi";
import {nonCashValidate} from "../../../../validation/scheme/nonCash";

const TransferSaledModal = memo(({
                                     isOpen,
                                     submitTransferSaledStore,
                                     handleCloseModal,
                                     data,
                                     modalError,
                                     isModalLoading,
                                     viewDocument,
                                     isOverestimationTransfer,
                                     setIsOverestimationTransfer,
                                     submitOverestimation,
                                     garage,
                                     requestDealForTransfer,
                                     requestCurrentState,
                                 }) => {
        const form = useForm({
            mode: 'all',
            defaultValues: {
                deposit: {
                    cash: 0, nonCash: 0, bankTransaction: 0
                }
            },
            resolver: joiResolver(transferSaledModalSchema)
        });

        const cashValue = form.watch('deposit.cash') || 0;
        const nonCash = form.watch('deposit.nonCash') || 0;
        const bankTransaction = form.watch('deposit.bankTransaction') || 0;
        const total = +cashValue + +nonCash + +bankTransaction;
        const [basicAlertModal, setBasicAlertModal] = useState({
                state: false,
                message: ''
            });
        const [paymentType, setPaymentType] = useState('Наличные');
        const [change, setChange] = useState(null);
        const [paymentInputs, setPaymentInputs] = useState([])
        const cashMinusChange = +cashValue - change

        const handlePaymentTypeChange = (e) => {
           setPaymentType(e.target.value)
        };

        const {accessFeatures} = useSelector(({user}) => user);
        const notEmpty = data && data.length !== 0;
        const disabledSaveTransfer = !garage && isOverestimationTransfer;
        const isNonCashOperationCrediton = accessFeatures['non_cash.operations.type']
        const isGarage = !garage;

        useEffect(() => {
            if (!garage && requestCurrentState) {
                requestDealForTransfer();
            }
        }, [requestCurrentState])

    const handleSubmit = () => {
        const values = form.getValues();
        const totalEstimatedValue = calculateTotal('totalEstimatedValue');

        const { error } = nonCashValidate.validate({
            cash: cashValue,
            nonCash: nonCash,
            bankTransaction: bankTransaction
        });

        const sumEstimatedValue = data.reduce((p, c) => p + c.totalEstimatedValue, 0).toFixed(2);
        const expectedTotal = isNonCashOperationCrediton ? (total - change).toFixed(2) : total.toFixed(2);
        const expectedMessage = isNonCashOperationCrediton && !paymentInputs.length 
            ? paymentErrors.PAYMENT_TYPE_REQUIRED 
            : paymentErrors.PRICE_MISMATCH

        if (isGarage && (expectedTotal !== sumEstimatedValue || error)) {
            setBasicAlertModal({
                state: true,
                message: expectedMessage
            });
            return;
        }

        const cash = values.payment === "Наличные";

        const newDeposit = {
            cash: cashMinusChange,
            nonCash: +nonCash,
            bankTransaction: +bankTransaction
        };

        const depositGarage = {
            cash: cash ? totalEstimatedValue : 0,
            nonCash: !cash ? totalEstimatedValue : 0,
            bankTransaction: +bankTransaction
        };

        submitTransferSaledStore(cash, garage ? depositGarage : newDeposit);
    };

        const closeModal = () => {
            if (!garage) {
                setIsOverestimationTransfer(false)
            }
            handleCloseModal(viewDocument);
        }

        function calculateTotal(name) {
            if (!Array.isArray(data)) {
                return 0;
            }

            return data.reduce((total, item) => {
                if (typeof item === 'object' && name in item && typeof item[name] === 'number') {
                    return total + item[name];
                }
                return total;
            }, 0);
        }

        const closeBasicAlertModal = () => setBasicAlertModal({state: false});

        return <ReactModal
            isOpen={isOpen}
            contentLabel="Modal"
            className="modal-container transferSaledStoreModal-scroll"
            overlayClassName="modal-overlay">
            <FormProvider
                onSubmit={handleSubmit}
                {...form}
            >
                {modalError && <Message type="error" text={modalError}/>}
                <div className="modal-header transferSaledStoreModal-modal-header">
                    <h2>Реализация товара</h2>
                </div>
                <div className="modal-body transferSaledStoreModal-modal-body">
                    {isModalLoading ? (<Loader/>) : (<>
                        {
                            garage &&
                            <HRadio h="true"
                                    labels={['Наличные', 'Безналичные']}
                                    name="payment"
                                    checkboxStyle={true}
                                    onChange={handlePaymentTypeChange}
                                    defaultCheckedLabel={paymentType}
                            />
                        }
                        <div className="transferSaledStoreModal-scroll-table">
                            <table className="table hover ">
                                <thead>
                                <tr className="transferSaledStoreModal-table-header">
                                    <th scope="col">
                                        <p>Номер договора</p>
                                    </th>
                                    <th scope="col">
                                        <p>Наименование</p>
                                    </th>
                                    <th scope="col">
                                        <p>Сумма на текущий день, руб.</p>
                                    </th>
                                    {
                                        isGarage &&
                                        <>
                                            <th scope="col">
                                                <p>Микрозайм,<br/> руб.</p>
                                            </th>
                                            <th scope="col">
                                                <p>Начисленные проценты, руб.</p>
                                            </th>
                                        </>
                                    }
                                    <th scope="col">
                                        {
                                            isGarage
                                                ? <p>Цена реализации,<br/> руб.</p>
                                                : <p>Оценочная <br/>стоимость, руб.</p>
                                        }
                                    </th>
                                    <th scope="col" className='transferSaledStoreModal-table-tdItem'>
                                        <p>Количество</p>
                                    </th>
                                </tr>
                                </thead>
                            </table>
                            <div className="transferSaledStoreModal-scroll-table-body">
                                <table className="table hover">
                                    <tbody>
                                    {notEmpty && data.map((i) => {
                                        let check = i.hasOwnProperty('totalEstimatedValue');
                                        return <tr key={i.id}>
                                            <td><p>{i.dealNumber || i.id}</p></td>
                                            <td><p>{check && i.positions[0].names.join(', ')}</p></td>
                                            <td><p>{check && i.totalToPay.toFixed(2)}</p></td>
                                            {
                                                isGarage &&
                                                <>
                                                    <td><p>{check && i.amount.toFixed(2)}</p></td>
                                                    <td><p>{check && i.accruedInterest.toFixed(2) || 0}</p></td>
                                                </>
                                            }
                                            <td><p>{check && i.totalEstimatedValue.toFixed(2)}</p></td>
                                            <td className='transferSaledStoreModal-table-tdItem'>
                                                <p>{check && i.positions[0].quantity}</p>
                                            </td>
                                        </tr>
                                    })}
                                    </tbody>
                                </table>
                            </div>
                            <table className="table hover">
                                <tfoot>
                                <tr className="transferSaledStoreModal-table-footer">
                                    <td colSpan="2">
                                        <p>Итого</p>
                                    </td>
                                    <td>
                                        <p>{calculateTotal('totalToPay').toFixed(2)} руб.</p>
                                    </td>
                                    {
                                        isGarage &&
                                        <>
                                            <td><p>{calculateTotal('amount').toFixed(2)} руб.</p></td>
                                            <td><p>{calculateTotal('accruedInterest').toFixed(2)} руб.</p></td>
                                        </>
                                    }
                                    <td><p>{calculateTotal('totalEstimatedValue').toFixed(2)} руб.</p></td>
                                    <td className='transferSaledStoreModal-table-tdItem'>
                                        <p>{notEmpty && data.reduce((p, c) => p + c.positions[0].quantity, 0)}</p>
                                    </td>
                                </tr>
                                </tfoot>
                            </table>
                        </div>
                    </>)}
                    {isGarage && (
                        isNonCashOperationCrediton
                            ? <PaymentTypeSelector 
                                form={form} 
                                maxTotalSum={calculateTotal('totalEstimatedValue').toFixed(2)}
                                calculateTotalSum={total}
                                inputFieldName={'deposit'}
                                isFilter={isGarage}
                                setCashChangePayment={setChange}
                                setPaymentInputs={setPaymentInputs}
                                /> 
                            : <NonCash/>)}
                    
                    {
                        isGarage && !isNonCashOperationCrediton &&
                        <div className='transferSaledStoreModal-amountContributed'>
                            <h3>Итого внесено:</h3>
                            <h3>{total.toFixed(2) || 0}</h3>
                        </div>
                    }
                </div>
                <div className="modal-footer transferSaledStoreModal-modal-footer">
                    <div>
                        <ActionButton
                            text={isGarage ? "Принять деньги" : "Сохранить"}
                            disabled={disabledSaveTransfer}
                            styleName={disabledSaveTransfer ? "button-light" : "button"}
                            func={handleSubmit}
                        />
                        {permissionsAccess("action.deal.update.thing.estimated.value") && accessFeatures['deal.expired.revaluation'] && !garage &&
                            <ActionButton
                                text="Переоценка"
                                styleName={isOverestimationTransfer ? 'button-light' : 'button'}
                                func={() => setIsOverestimationTransfer(true)}
                                disabled={isOverestimationTransfer}
                            />}
                    </div>
                    <ActionButton
                        text="Отменить"
                        func={closeModal}
                        styleName="button-light"
                    />
                </div>
                <BasicAlert onClose={() => closeBasicAlertModal()}
                            message={basicAlertModal.message}
                            isOpen={basicAlertModal.state}
                            isError={true}
                />
            </FormProvider>
            {!garage && isOverestimationTransfer && <OverestimationLayout
                view={true}
                submitOverestimation={submitOverestimation}
                data={data}
                handleCloseModal={() => setIsOverestimationTransfer(false)}
            />}
        </ReactModal>
    },
);

export default TransferSaledModal;
